import { GLOBAL } from '@lumapps/translations';

export const INTERVAL_CONNECTION_WINDOW_TIMER = 1000;

export const CLOSE_CONNECTION_WINDOW_KEY = '/v2/oauth2/callback';

export const CONNECTION_WINDOW_OPTIONS =
    'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes,resizable=yes, width=600, height=600';

export const defaultIntegrationConnectorExtensions = [GLOBAL.DRIVE, GLOBAL.CALENDAR, GLOBAL.EMAIL, GLOBAL.CHAT];
